/* unplugin-vue-components disabled */import { render } from "./CustomerCreateForm.vue?vue&type=template&id=516270b6&ts=true"
import script from "./CustomerCreateForm.vue?vue&type=script&lang=ts"
export * from "./CustomerCreateForm.vue?vue&type=script&lang=ts"

import "./CustomerCreateForm.vue?vue&type=style&index=0&id=516270b6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__